/**
 * WebMCP — Expose site tools to AI agents via the browser.
 * Spec: https://webmachinelearning.github.io/webmcp/
 *
 * Registers tools only when navigator.modelContext is available (Chrome with WebMCP).
 */

(function () {
  if (!('modelContext' in navigator)) return;

  const siteUrl = window.location.origin;

  const tools = [
    {
      name: 'search',
      description:
        'Search BudgetFitter for deals, brands, and tools by keyword.',
      inputSchema: {
        type: 'object',
        properties: {
          query: { type: 'string', description: 'Search query' },
          limit: {
            type: 'integer',
            description: 'Max results (1-20)',
            default: 5,
          },
        },
        required: ['query'],
      },
      async execute(args) {
        const res = await fetch(`${siteUrl}/mcp`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            jsonrpc: '2.0',
            id: 1,
            method: 'tools/call',
            params: { name: 'search', arguments: args },
          }),
        });
        const data = await res.json();
        return data.result?.content?.[0]?.text ?? JSON.stringify(data);
      },
    },
    {
      name: 'brand_lookup',
      description:
        'Get brand data, discount codes, and deal intelligence by brand slug.',
      inputSchema: {
        type: 'object',
        properties: {
          slug: {
            type: 'string',
            description: 'Brand URL slug (e.g., amazon, nike)',
          },
        },
        required: ['slug'],
      },
      async execute(args) {
        const res = await fetch(`${siteUrl}/mcp`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            jsonrpc: '2.0',
            id: 2,
            method: 'tools/call',
            params: { name: 'brand_lookup', arguments: args },
          }),
        });
        const data = await res.json();
        return data.result?.content?.[0]?.text ?? JSON.stringify(data);
      },
    },
    {
      name: 'get_llms_index',
      description: 'Retrieve the full LLMs.txt brand/category summary index.',
      inputSchema: {
        type: 'object',
        properties: {},
      },
      async execute() {
        const res = await fetch(`${siteUrl}/mcp`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            jsonrpc: '2.0',
            id: 3,
            method: 'tools/call',
            params: { name: 'get_llms_index', arguments: {} },
          }),
        });
        const data = await res.json();
        return data.result?.content?.[0]?.text ?? JSON.stringify(data);
      },
    },
    {
      name: 'navigate',
      description: 'Navigate to any page on BudgetFitter by path.',
      inputSchema: {
        type: 'object',
        properties: {
          path: {
            type: 'string',
            description: 'Relative path starting with / (e.g., /brand/nike/)',
          },
        },
        required: ['path'],
      },
      async execute(args) {
        const path = args.path || '/';
        const url = `${siteUrl}${path.startsWith('/') ? path : '/' + path}`;
        window.location.href = url;
        return JSON.stringify({ navigated: true, url });
      },
    },
  ];

  // Register all tools
  tools.forEach((tool) => {
    try {
      navigator.modelContext.registerTool(tool);
    } catch (e) {
      // Silently fail if API shape differs or tool already registered
    }
  });
})();
